import React from 'react';
import { Switch as AntdSwitch, Space, Tooltip } from 'antd';
import Title from 'antd/lib/typography/Title';
import { InfoCircleOutlined } from '@ant-design/icons';
interface SwitchProps {
  id: string;
  placeholder: string;
  secondLabel?: string;
  name: string;
  onHandleChange: (checked: boolean) => void;
  defaultChecked: boolean;
  isDisabled?: boolean;
}

export const Switch: React.FC<SwitchProps> = ({
  id,
  name,
  placeholder,
  secondLabel,
  onHandleChange,
  defaultChecked,
  isDisabled,
}) => {
  if (name === 'demandPublish' || name === 'isNotifiable') onHandleChange(true);

  return (
    <>
      {secondLabel && name !== 'isPublic' && (
        <Title level={5}>Notifier les utilisateurs Ensembl' : </Title>
      )}
      <Space>
        <label>{placeholder}</label>
        <div id={id}>
          <AntdSwitch
            onChange={onHandleChange}
            defaultChecked={defaultChecked}
            disabled={isDisabled}
          />
        </div>
        {secondLabel && <span>{secondLabel}</span>}
        {name === 'isPublic' && (
          <Tooltip
            placement="top"
            title="Cette option permet de publier uniquement dans les villes des groupes sélectionnés."
          >
            <InfoCircleOutlined style={{ cursor: 'pointer' }} />
          </Tooltip>
        )}
      </Space>
    </>
  );
};
